module.exports = __webpack_public_path__ + "static/media/meeting_room.bbd965fa.png";